<script>
export default {
  data() {
    return {
      list: [{ value: null }],
      isLimited: false,
    };
  },
  props: ["appAuthList"],
  mounted() {
    if (Array.isArray(this.appAuthList)) {
      this.list = this.appAuthList.map((i) => {
        return { value: i.id };
      });
    }
  },
  computed: {
    isAdd: function() {
      return !this.appAuthList;
    },
  },
  render() {
    const items = this.list.map((item, index) => {
      const exclude = this.list
        .filter((i) => i.value !== item.value)
        .map((i) => i.value)
        .filter(Boolean);
      const conditions = [{ or: [{ key: "openPlat.id", op: "isNull" }] }];
      const updateIncludeSelf = { key: "id", vals: [item.value] };
      if (!this.isAdd) {
        conditions[0].or.push(updateIncludeSelf);
      }
      // 处理选中第一个后 限制同一个租户下的appID
      if (index > 0 && this.isLimited) {
        conditions.push({ key: "tenCode", vals: [item.tenCode] });
      }
      const conf = {
        props: {
          disable: index === 0 && !this.isAdd,
          fields: ["tenCode", "openPlat.id"],
          model: "wechat-app",
          placeholder: "请选择公众号或者小程序",
          outlined: true,
          keyLabel: "nickName",
          keyValue: "id",
          value: item.value,
          excludeByKey: exclude,
          simpleMode: true,
          conditions,
        },
        on: {
          input(e, row) {
            Object.assign(item, row);
            item.value = e;
          },
        },
      };
      const addBtn = (
        <q-item-section avatar>
          <q-btn
            size="sm"
            icon="add"
            color="primary"
            on-click={() => {
              this.list.push({ value: null });
            }}></q-btn>
        </q-item-section>
      );
      const removeBtn = (
        <q-item-section avatar>
          <q-btn
            size="sm"
            icon="remove"
            color="negative"
            on-click={() => {
              this.list.splice(index, 1);
            }}></q-btn>
        </q-item-section>
      );
      return (
        <q-item>
          {index > 0 && !this.isAdd && removeBtn}
          {index === 0 && !this.isAdd && addBtn}
          <q-item-section>
            <rs-select class="rs-size-sm" {...conf}></rs-select>
          </q-item-section>
        </q-item>
      );
    });
    const check = (
      <q-item>
        <q-checkbox label="只限同租户下的授权小程序公众号" v-model={this.isLimited}></q-checkbox>{" "}
      </q-item>
    );
    return <q-list>{items}</q-list>;
  },
};
</script>
